import React from "react";
import { AuroraBackground } from "../../components/ui/aurora-background";

const BACKER_LOGOS = [
  {
    src: "/backed_by/Amazon Logo Wit Bewerkt.png",
    link: "https://aws.amazon.com/startups"
  },
  {
    src: "/backed_by/Perplexity Bewerkt.png",
    link: "https://www.perplexity.ai/business-fellowship"
  },
  {
    src: "/backed_by/UT.png",
    link: "https://www.utwente.nl/en/"
  },
  {
    src: "/backed_by/Ontwerp 2048x669 van Photopea.png",
    link: "https://kickstart.ai/"
  },
  {
    src: "/backed_by/AIC4NL.png",
    link: "https://aic4nl.nl/"
  },
  {
    src: "/backed_by/Novel-T Logo Wit 2018.png",
    link: "https://novelt.com/nl/"
  },
  {
    src: "backed_by/comm-eit.png",
    link: "https://www.eit.europa.eu/our-activities/opportunities/eit-ai-founders-club-2025"
  }
];

const LogoTopLeft: React.FC = () => (
  <div className="absolute top-0 left-0 pt-4 md:pt-6 lg:pt-8 pl-4 md:pl-8 z-20 flex items-center gap-2">
    <img
      src="/assets/rhea/logo.png"
      alt="Thoughtful Oasis Logo"
      className="h-8 md:h-10 lg:h-12 object-contain drop-shadow-lg"
      style={{ maxWidth: 50 }}
    />
    <span className="hidden sm:inline text-white text-lg md:text-xl lg:text-2xl font-bold">Thoughtful Oasis</span>
  </div>
);

const LandingNavbar: React.FC = () => (
  <nav className="flex bg-transparent transition-colors duration-700 flex-row absolute top-0 right-0 pt-4 md:pt-6 lg:pt-8 pr-4 md:pr-8 lg:pr-12 z-30 text-white justify-end items-center">
    <div className="flex flex-row gap-4 md:gap-6 lg:gap-8 text-base md:text-lg font-semibold">
      <a href="https://arxiv.org/abs/2505.14940" className="hover:text-pitchDeckTeal transition-colors duration-200">Research</a>
      <a href="https://iamrhea.com/nl" className="hover:text-pitchDeckTeal transition-colors duration-200">Try Rhea</a>
      <a href="/about-us" className="hover:text-pitchDeckTeal transition-colors duration-200">About Us</a>
    </div>
  </nav>
);

const NLLanding = () => {
  return (
    <AuroraBackground className="h-fit min-h-[100vh] bg-pitchDeckBlack">
      <LogoTopLeft />
      <LandingNavbar />
      <div className="flex h-[80vh] w-full items-center relative z-10">
        <div className="flex flex-col items-start max-w-4xl px-4 md:px-12 lg:px-24 pt-28 md:pt-36 lg:pt-44">
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold mb-4 md:mb-6 drop-shadow-lg text-left text-white">
            Search engines for language-driven industries
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 md:mb-6 text-left text-white">
            Ontological vector databases for interpretable and auditable Retrieval Augmented Generation.
          </h2>
          <p className="max-w-xl text-left mb-6 md:mb-10 text-base md:text-lg lg:text-xl font-mono opacity-90 text-white">
            For searches that need more than semantic and keyword similarity search, in industries where queries do not resemble the found entities.
          </p>
          <a
            href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ09k3gOrghdyeSSAHodK3yt17L8qzzDQCxhwzDs5c4iNSOhGEpVGkTB5Q2NaKodYhPWgchdh61Q"
            className="bg-white text-pitchDeckBlack font-bold px-6 md:px-8 py-3 md:py-4 rounded shadow-lg text-base md:text-lg hover:bg-pitchDeckTeal hover:text-white transition-colors duration-200"
          >
            Schedule a Demo
          </a>
        </div>
      </div>
      <div className="w-full flex flex-col items-center justify-center pb-8 mt-12">
        <div className="text-pitchDeckWhite text-lg font-semibold mb-4 opacity-80">Backed by</div>
        <div className="flex flex-row flex-wrap gap-2 justify-center items-center w-full">
          {BACKER_LOGOS.map(({ src, link }, idx) => (
            <a
              key={src}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity duration-300"
            >
              <img
                src={src}
                alt={`Backer logo ${idx + 1}`}
                className={`h-12 md:h-16 object-contain brightness-0 invert hover:brightness-100 hover:invert-0 transition-all duration-300 rounded p-2 ${
                  src.includes('Perplexity') ? 'h-16 md:h-28' : src.includes('fundedUHD') ? 'h-24 md:h-40' : ''
                }`}
                style={{ maxWidth: src.includes('Perplexity') ? 220 : src.includes('fundedUHD') ? 300 : 180 }}
              />
            </a>
          ))}
        </div>
      </div>
    </AuroraBackground>
  );
};

export default NLLanding;